<template>
  <AccountantsSubmenu
    :items="menuItems"
  >
    <template v-slot:titletop>
      <!-- <div class="submenu-title">
        {{ $gettext('Ledger') }}
      </div> -->
    </template>
  </AccountantsSubmenu>
</template>

<script>
import AccountantsSubmenu from '@/components/accountants/menus/AccountantsSubmenu.vue'

export default {
  name: 'AccountantsLedgerMenu',
  components: { AccountantsSubmenu },
  computed: {
    menuItems() {
      return [
        {
          label: this.$gettext('Cost categories'),
          name: 'Ledger',
          icon: 'fa-table-list',
          analytics: 'ledger cost categories',
        },
        {
          label: this.$gettext('Ledger categories'),
          name: 'LedgerCategoriesTable',
          icon: 'fa-layer-group',
          analytics: 'ledger categories',
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
</style>
